// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label_Bcix_ {
  font: 600 13px/20px Inter;
  color: var( --color-base700 );
}
.label_Bcix_.label-inputTitle_UUZ5d {
  font: 600 13px/20px Inter;
  color: var( --color-base700 );
}
.label_Bcix_.label-inputTitle_UUZ5d.label-checkboxTitle__IAHE {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.label_Bcix_.label-inputCaption_pNvRG {
  font: 13px/20px Inter;
  color: #394756;
}
.label_Bcix_.label-touchToolbarLabel_I7GxM {
  font: normal 15px/24px Inter;
  color: var( --color-base700 );
}
.label_Bcix_.label-checkboxLabel_ZAm5N {
  font: normal 15px/24px Inter;
  color: #394756;
  overflow: unset;
  white-space: normal;
  text-overflow: unset;
}
.label_Bcix_.label-mobileUserNavBarNested_jW29_ {
  color: var( --color-base700 );
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding-top: 12px;
  padding-left: 8px;
  padding-bottom: 12px;
}
.label_Bcix_.label-checkboxLabelWrap_Kj2pY {
  font: normal 15px/24px Inter;
  color: #394756;
  overflow: unset;
  white-space: normal;
  text-overflow: unset;
}
.label_Bcix_.label-subtitle_NsdX5 {
  font: bold 16px/24px Inter;
  color: #394756;
  padding-top: var( --size-padLarge );
  padding-bottom: var( --size-padLarge );
}
.label_Bcix_.label-captionSmallBold_B1s_z {
  font: 600 12px/18px Inter;
  color: #394756;
}
.label_Bcix_.label-captionSmall_gh3fp {
  font: normal 12px/18px Inter;
  color: #394756;
}
.label_Bcix_.label-inputCaption_pNvRG.label-helperText_ENU4C {
  color: var( --color-base500 );
}
.label_Bcix_.label-formSectionTitle_LRtYp {
  font: bold var( --size-fontH3 )/24px Inter;
  color: #394756;
}
.label_Bcix_.label-inputTitle_UUZ5d.label-input_JPiNT.label-inputHeader_HNGLz {
  font-size: var( --size-fontBodySmall );
}
.label_Bcix_.label-locatorReplacement_kEhqn {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}
.label_Bcix_.label-sectionTitle_NVBKn {
  color: var( --color-base800 );
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
}
.label_Bcix_.label-pairing_Rhe_g {
  font: 400 13px/20px Inter;
  color: var( --color-base700 );
}`, "",{"version":3,"sources":["webpack://./src/theme/Label.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B","sourcesContent":[".label {\n  font: 600 13px/20px Inter;\n  color: var( --color-base700 );\n}\n.label.label-inputTitle {\n  font: 600 13px/20px Inter;\n  color: var( --color-base700 );\n}\n.label.label-inputTitle.label-checkboxTitle {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.label.label-inputCaption {\n  font: 13px/20px Inter;\n  color: #394756;\n}\n.label.label-touchToolbarLabel {\n  font: normal 15px/24px Inter;\n  color: var( --color-base700 );\n}\n.label.label-checkboxLabel {\n  font: normal 15px/24px Inter;\n  color: #394756;\n  overflow: unset;\n  white-space: normal;\n  text-overflow: unset;\n}\n.label.label-mobileUserNavBarNested {\n  color: var( --color-base700 );\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  padding-top: 12px;\n  padding-left: 8px;\n  padding-bottom: 12px;\n}\n.label.label-checkboxLabelWrap {\n  font: normal 15px/24px Inter;\n  color: #394756;\n  overflow: unset;\n  white-space: normal;\n  text-overflow: unset;\n}\n.label.label-subtitle {\n  font: bold 16px/24px Inter;\n  color: #394756;\n  padding-top: var( --size-padLarge );\n  padding-bottom: var( --size-padLarge );\n}\n.label.label-captionSmallBold {\n  font: 600 12px/18px Inter;\n  color: #394756;\n}\n.label.label-captionSmall {\n  font: normal 12px/18px Inter;\n  color: #394756;\n}\n.label.label-inputCaption.label-helperText {\n  color: var( --color-base500 );\n}\n.label.label-formSectionTitle {\n  font: bold var( --size-fontH3 )/24px Inter;\n  color: #394756;\n}\n.label.label-inputTitle.label-input.label-inputHeader {\n  font-size: var( --size-fontBodySmall );\n}\n.label.label-locatorReplacement {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n.label.label-sectionTitle {\n  color: var( --color-base800 );\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n}\n.label.label-pairing {\n  font: 400 13px/20px Inter;\n  color: var( --color-base700 );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_Bcix_`,
	"label-inputTitle": `label-inputTitle_UUZ5d`,
	"label-checkboxTitle": `label-checkboxTitle__IAHE`,
	"label-inputCaption": `label-inputCaption_pNvRG`,
	"label-touchToolbarLabel": `label-touchToolbarLabel_I7GxM`,
	"label-checkboxLabel": `label-checkboxLabel_ZAm5N`,
	"label-mobileUserNavBarNested": `label-mobileUserNavBarNested_jW29_`,
	"label-checkboxLabelWrap": `label-checkboxLabelWrap_Kj2pY`,
	"label-subtitle": `label-subtitle_NsdX5`,
	"label-captionSmallBold": `label-captionSmallBold_B1s_z`,
	"label-captionSmall": `label-captionSmall_gh3fp`,
	"label-helperText": `label-helperText_ENU4C`,
	"label-formSectionTitle": `label-formSectionTitle_LRtYp`,
	"label-input": `label-input_JPiNT`,
	"label-inputHeader": `label-inputHeader_HNGLz`,
	"label-locatorReplacement": `label-locatorReplacement_kEhqn`,
	"label-sectionTitle": `label-sectionTitle_NVBKn`,
	"label-pairing": `label-pairing_Rhe_g`
};
export default ___CSS_LOADER_EXPORT___;
